<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-7.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Pre-2004 Jumps Adjustments</span>
</div>
<app-modal
  [active]="modal.active"
  [data]="modal.data"
>
</app-modal>
<div class="random-actions"></div>
<app-table
  hasActions="true"
  [rows]="pre2004Jumps"
  [settings]="settings"  
  [columns]="headings"
  [tableCellTemplate]="cellTemplate"
>
  <ng-template #cellTemplate let-cell="cell">
    <div class="cell">
      <span>{{ cell.value }}</span>
    </div>
  </ng-template>
</app-table>
